import { type ReactNode } from 'react';

import { memoWithDisplayName } from '@/packages/utils';

import { MapContainer } from '../../components/MapContainer';
import { MapAppContextProvider } from '../../context/mapAppContext';
import { type MapAppContext } from '../../types/mapAppContext';

type ApplicationProps = {
  context: MapAppContext;
};

function App({ context }: ApplicationProps): ReactNode {
  return (
    <MapAppContextProvider value={context}>
      <MapContainer />
    </MapAppContextProvider>
  );
}

export const Application = memoWithDisplayName(App, 'Application');
